import type React from 'react';

import { Avatar } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

type Props = {
	displayName: string;
	photo: {
		userMedium: {
			processing: boolean;
			url: string;
		};
	} | null;
};

export const DmAvatar: React.FC<Props> = ({ displayName, photo }) => {
	const { translate } = useI18n();
	const photoUrl = photo?.userMedium.processing ? undefined : photo?.userMedium.url;

	return (
		<div className="z-9 flex w-20 shrink-0 flex-col items-center -space-y-8">
			<Avatar
				src={photoUrl}
				size={80}
				alt={translate('corgi.petition.starter_dashboard_v2.decision_makers.cards.avatar_alt', {
					display_name: displayName,
				})}
			/>
			<div
				data-testid="dm-title-icon"
				data-qa="dm-title-icon"
				className="border-stroke-inverse-strong bg-fill-accent-primary-weaker z-10 flex h-14 w-14 items-center justify-center gap-1.5 rounded-full border-4 border-solid p-1"
			>
				<span>
					<DecisionMakerIcon className="text-typography-accent-primary h-6 w-6" />
				</span>
			</div>
		</div>
	);
};
